/**
 * Socrative Activity Image - The component used to display images in activities. This component is used
 *                            in both the student quiz view and the teacher question drilldown view.
 *
 * An activity image is composed of the following visual elements:
 *
 *     - A placeholder icon displayed while the image is loading
 *     - An image
 *     - A magnifying glass icon below the image
 *     - A label below the image whose text is "zoom"
 *
 * Properties:
 *
 *     className {string} CSS class applied to the entire component (usually for positioning or sizing)
 *     imageUrl  {string} URL of the image to be displayed
 *     isAnswerImage {boolean} If the image is for an answer
 */

import * as React from 'react';

import { translate } from '~l10n/client';

import ImageIcon from 'ImageIcon';
import SearchIcon from 'SearchIcon';
import zoomModal from 'ZoomController';

export default class ActivityImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageLoading: true,
      imageLoaded: false,
      imageFailed: false,
      imageUrl: props.imageUrl,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      imageUrl: nextProps.imageUrl,
    };
  }

  render() {
    let children = [
      <img
        key="children-img-1"
        className={
          'activity-image' + (this.state.imageLoaded ? '' : ' old-hidden')
        }
        src={this.state.imageUrl}
        onLoad={() => {
          this.setState({
            imageLoaded: true,
            imageLoading: false,
            imageFailed: false,
          });
        }}
        onError={() => {
          this.setState({
            imageLoading: false,
            imageFailed: true,
          });
        }}
        onClick={() => {
          if (this.state.imageLoaded && !this.props.isAnswerImage) {
            zoomModal.open(this.props.imageUrl);
          }
        }}
      />,
    ];

    if (!this.state.imageLoaded) {
      children.push(
        <div
          key="children-div-1"
          className="activity-image-placeholder-container"
        >
          <ImageIcon className="activity-image-placeholder" />
          {this.state.imageFailed && (
            <div className="activity-image-reload">
              <button
                className="button button-primary "
                disabled={this.state.imageLoading}
                onClick={() => {
                  if (!this.state.imageLoading) {
                    this.setState({
                      imageLoading: true,
                      imageUrl:
                        this.props.imageUrl + `#${new Date().getTime()}`,
                    });
                  }
                }}
              >
                {translate('Reload Image')}
              </button>
            </div>
          )}
        </div>
      );
    } else {
      children.push(
        <div
          key="children-div-2"
          className={'activity-zoom-button'}
          onClick={(event) => {
            if (this.state.imageLoaded) {
              event.stopPropagation();
              event.preventDefault();

              zoomModal.open(this.props.imageUrl);
            }
          }}
        >
          <div className={'activity-image-zoom-icon-container'}>
            <SearchIcon className={'activity-image-zoom-icon'} />
          </div>
          <div className={'activity-image-zoom-label'}>{translate('Zoom')}</div>
        </div>
      );
    }

    return (
      <div
        className={
          'activity-image-container' +
          (this.props.className ? ` ${this.props.className}` : '')
        }
      >
        {children}
      </div>
    );
  }
}
